import { render } from "./BtnCallNav.vue?vue&type=template&id=b842ce68&scoped=true"
import script from "./BtnCallNav.vue?vue&type=script&lang=js"
export * from "./BtnCallNav.vue?vue&type=script&lang=js"

import "./BtnCallNav.vue?vue&type=style&index=0&id=b842ce68&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b842ce68"]])

export default __exports__